function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import * as JsxUtility from "../commons/JsxUtility";
import * as Api from "../ajax/SessionApi";
import * as SessionConfirmModalComponent from "./SessionConfirmModalComponent";
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import CustomDateComponent from "./CustomDateComponent";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Placeholder, Action, CreateSession } from '../commons/IntlMessages';
import { SceneTypes } from "../enum/SceneTypes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // 会議モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 3] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * 会議モーダルコンポーネント
 */


var SessionModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionModalComponent, _React$Component);

  var _super = _createSuper(SessionModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionModalComponent);

    _this = _super.call(this, props);
    var nowStart = moment().startOf('minutes');
    var nowEnd = nowStart.clone().add('hours', 1);
    var specifyPeriod = false;
    var endDate = nowEnd;
    var endTimeHours = nowEnd.hours();
    var endTimeMinutes = nowEnd.minutes();

    if (_this.props.specifyPeriod != null) {
      // 期間指定フラグが保持されている場合
      specifyPeriod = _this.props.specifyPeriod;
    } else {
      if (_this.props.endDate != null) {
        // 終了日が保持されていた場合
        specifyPeriod = Utility.IsSpecifyPeriodMoment(_this.props.endDate);
      } else if (_this.props.endDateTime != null) {
        // その他の場合
        specifyPeriod = Utility.IsSpecifyPeriodDate(_this.props.endDateTime);
      }
    }

    if (_this.props.endDate != null) {
      endDate = _this.props.endDate;

      if (_this.props.endTimeHours != null) {
        endTimeHours = _this.props.endTimeHours;
      } else {
        endTimeHours = Number(_this.props.endDate.format("HH"));
      }

      if (_this.props.endTimeMinutes != null) {
        endTimeMinutes = _this.props.endTimeMinutes;
      } else {
        endTimeMinutes = Number(_this.props.endDate.format("mm"));
      }
    } else {
      if (_this.props.endDateTime != null) {
        endDate = Utility.ToMoment(_this.props.endDateTime);
        endTimeHours = Number(Utility.ToMoment(_this.props.endDateTime).format("HH"));
        endTimeMinutes = Number(Utility.ToMoment(_this.props.endDateTime).format("mm"));
      }
    }

    var startDate = nowEnd;
    var startTimeHours = nowEnd.hours();
    var startTimeMinutes = nowEnd.minutes();

    switch (props.mode) {
      case Mode.Add:
        startDate = _this.props.startDate != null ? _this.props.startDate : nowStart;
        startTimeHours = _this.props.startTimeHours != null ? _this.props.startTimeHours : nowStart.hours();
        startTimeMinutes = _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : nowStart.minutes();

        if (!specifyPeriod) {
          endDate = moment({
            year: startDate.year(),
            month: startDate.month(),
            day: startDate.date(),
            hour: startTimeHours,
            minute: startTimeMinutes
          }).clone().add('hours', 1);
          endTimeHours = endDate.hours();
          endTimeMinutes = endDate.minutes();
        }

        _this.state = {
          Modal: null,
          SessionName: _this.props.sessionName,
          StartDate: startDate,
          StartTimeHours: startTimeHours,
          StartTimeMinutes: startTimeMinutes,
          EndDate: endDate,
          EndTimeHours: endTimeHours,
          EndTimeMinutes: endTimeMinutes,
          SpecifyPeriod: specifyPeriod,
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          Scene: null,
          Request: null,
          SessionConfirmModalMode: SessionConfirmModalComponent.Mode.None,
          ErrorMessages: []
        };
        break;

      case Mode.Modify:
        if (_this.props.startDateTime == null || _this.props.endDateTime == null) {
          throw Error();
        }

        startDate = _this.props.startDate != null ? _this.props.startDate : Utility.ToMoment(_this.props.startDateTime);
        startTimeHours = _this.props.startTimeHours != null ? _this.props.startTimeHours : Number(Utility.ToMoment(_this.props.startDateTime).format("HH"));
        startTimeMinutes = _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : Number(Utility.ToMoment(_this.props.startDateTime).format("mm"));

        if (!specifyPeriod) {
          endDate = moment({
            year: startDate.year(),
            month: startDate.month(),
            day: startDate.date(),
            hour: startTimeHours,
            minute: startTimeMinutes
          }).clone().add('hours', 1);
          endTimeHours = endDate.hours();
          endTimeMinutes = endDate.minutes();
        }

        _this.state = {
          Modal: null,
          SessionName: _this.props.sessionName,
          StartDate: startDate,
          StartTimeHours: startTimeHours,
          StartTimeMinutes: startTimeMinutes,
          EndDate: endDate,
          EndTimeHours: endTimeHours,
          EndTimeMinutes: endTimeMinutes,
          SpecifyPeriod: specifyPeriod,
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          Scene: null,
          Request: null,
          SessionConfirmModalMode: SessionConfirmModalComponent.Mode.None,
          ErrorMessages: []
        };
        break;

      case Mode.ReadOnly:
        if (!_this.props.startDateTime || !_this.props.endDateTime) {
          throw Error();
        }

        startDate = _this.props.startDate != null ? _this.props.startDate : Utility.ToMoment(_this.props.startDateTime);
        startTimeHours = _this.props.startTimeHours != null ? _this.props.startTimeHours : Number(Utility.ToMoment(_this.props.startDateTime).format("HH"));
        startTimeMinutes = _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : Number(Utility.ToMoment(_this.props.startDateTime).format("mm"));

        if (!specifyPeriod) {
          endDate = moment({
            year: startDate.year(),
            month: startDate.month(),
            day: startDate.date(),
            hour: startTimeHours,
            minute: startTimeMinutes
          }).clone().add('hours', 1);
          endTimeHours = endDate.hours();
          endTimeMinutes = endDate.minutes();
        }

        _this.state = {
          Modal: null,
          SessionName: _this.props.sessionName,
          StartDate: startDate,
          StartTimeHours: startTimeHours,
          StartTimeMinutes: startTimeMinutes,
          EndDate: endDate,
          EndTimeHours: endTimeHours,
          EndTimeMinutes: endTimeMinutes,
          SpecifyPeriod: specifyPeriod,
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          Scene: null,
          Request: null,
          SessionConfirmModalMode: SessionConfirmModalComponent.Mode.None,
          ErrorMessages: []
        };
        break;

      default:
        throw Error;
    }

    _this.loadScene();

    return _this;
  }
  /**
   * シーンの読込
   */


  _createClass(SessionModalComponent, [{
    key: "loadScene",
    value: function loadScene() {
      var _this2 = this;

      if (this.state.Request != null) {
        this.state.Request.abort();
      }

      this.setState({
        Request: null
      });
      Api.GetScene(this.props.targetFolderName, this.state.SceneImageName, function (data) {
        _this2.setState({
          Scene: data
        });

        var loading = $(".loadingImage-0");
        var scene = $(".sceneImage-0");
        var scene360 = $(".scene360-0");
        loading.removeClass("loading-hidden");
        scene.addClass("loading-hidden");
        scene360.addClass("hidden");
        var sceneImage = _this2.state.SceneImageName;

        if (loading && scene && scene360) {
          if (scene.hasClass("loading-hidden")) {
            if (sceneImage) {
              var xhr = Api.GetSceneThubnail("", _this2.props.targetFolderName, sceneImage, 1, 0, 0, data.SceneType, function (x, y, type, file) {
                var loading = $(".loadingImage-" + x.toString());
                var capture = $(".sceneImage-" + x.toString());
                var scene360 = $(".scene360-" + x.toString());
                capture.attr('src', URL.createObjectURL(file));
                loading.addClass("loading-hidden");
                capture.removeClass("loading-hidden");

                if (type == SceneTypes._360DegreeImage) {
                  scene360.removeClass("hidden");
                }
              });

              _this2.setState({
                Scene: data,
                Request: xhr
              });
            } else {
              scene.attr('src', "/assets/img/noimage.png");
              loading.addClass("loading-hidden");
              scene.removeClass("loading-hidden");
            }
          }
        }
      });
    }
    /**
     * 会議名を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSessionName",
    value: function updateSessionName(e) {
      this.setState({
        SessionName: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 開始日を更新します。
     *
     * @param d 開始日
     */

  }, {
    key: "updateStartDate",
    value: function updateStartDate(d) {
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(d, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartDate: d,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 開始時刻（時）を更新します。
     *
     * @param e イベント44444
     */

  }, {
    key: "updateStartTimeHours",
    value: function updateStartTimeHours(e) {
      var startHour = Number(e.target.value);
      if (startHour > 23) startHour = 0;else if (startHour < 0) startHour = 23;
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(this.state.StartDate, startHour, this.state.StartTimeMinutes));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartTimeHours: startHour,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 開始時刻（分）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateStartTimeMinutes",
    value: function updateStartTimeMinutes(e) {
      var startMin = Number(e.target.value);
      if (startMin > 59) startMin = 0;else if (startMin < 0) startMin = 59;
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, startMin));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartTimeMinutes: startMin,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 終了日を更新します。
     *
     * @param d 終了日
     */

  }, {
    key: "updateEndDate",
    value: function updateEndDate(d) {
      this.setState({
        EndDate: d
      });
    }
    /**
     * 終了時刻（時）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateEndTimeHours",
    value: function updateEndTimeHours(e) {
      var endHour = Number(e.target.value);
      if (endHour > 23) endHour = 0;else if (endHour < 0) endHour = 23;
      this.setState({
        EndTimeHours: endHour
      });
    }
    /**
     * 終了時刻（分）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateEndTimeMinutes",
    value: function updateEndTimeMinutes(e) {
      var endMin = Number(e.target.value);
      if (endMin > 59) endMin = 0;else if (endMin < 0) endMin = 59;
      this.setState({
        EndTimeMinutes: endMin
      });
    }
    /**
     * 期間指定を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSpecifyPeriod",
    value: function updateSpecifyPeriod(e) {
      this.setState({
        SpecifyPeriod: e.target.checked
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;
        var startDateTime = Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes);
        var endDateTime = Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes); // 過去の時刻が設定されていたら現在時刻にする

        var currentDate = moment().startOf('minutes');

        if (moment(startDateTime).diff(currentDate) <= 0) {
          startDateTime = currentDate.toDate();
        }

        if (moment(endDateTime).diff(moment(startDateTime)) <= 0) {
          if (this.state.SpecifyPeriod) {
            this.state.ErrorMessages.push(intl.format(Errors.InputPariod));
          }
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        if (!this.state.SpecifyPeriod) {
          endDateTime = Utility.MaxDateTime.toDate();
        }

        this.props.onEntry(this.state.SessionName, startDateTime, endDateTime, this.state.SceneModelName, this.state.SceneImageName, this.props.targetFolderName);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;
        var currentDate = moment().startOf('minutes');
        var beforeStartDateTime = this.props.startDateTime != null ? this.props.startDateTime : currentDate.toDate();
        var startDateTime = Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes);
        var endDateTime = Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes);

        if (moment(startDateTime).diff(currentDate, "minutes") < 0 && moment(startDateTime).diff(moment(beforeStartDateTime), "minutes") != 0) {
          this.state.ErrorMessages.push(intl.format(Errors.InputPastStartDate));
        } else if (moment(endDateTime).diff(currentDate, "minutes") < 0) {
          if (this.state.SpecifyPeriod) {
            this.state.ErrorMessages.push(intl.format(Errors.InputPastEndDate));
          }
        } else if (moment(endDateTime).diff(moment(startDateTime), "minutes") <= 0) {
          if (this.state.SpecifyPeriod) {
            this.state.ErrorMessages.push(intl.format(Errors.InputPariod));
          }
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        if (!this.props.sessionId || !this.props.updateDateTime) {
          throw Error();
        }

        if (!this.state.SpecifyPeriod) {
          endDateTime = Utility.MaxDateTime.toDate();
        }

        this.props.onModify(this.props.sessionId, this.state.SessionName, startDateTime, endDateTime, this.state.SceneModelName, this.state.SceneImageName, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「複製」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDuplicate",
    value: function onDuplicate() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onDuplicate();
      this.state.Modal.modal('hide');
    }
    /**
     * 「削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDelete",
    value: function onDelete() {
      if (this.state.Modal == null || !this.props.sessionId || !this.props.updateDateTime) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;
      this.openSessionDeleteConfirmModal();
    }
    /**
     * 「変更」ボタン押下時の処理を行います。
     */

  }, {
    key: "onChangeScene",
    value: function onChangeScene() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onChangeScene(null, this.state.SessionName, this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes, this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes, this.state.SpecifyPeriod, true, true, this.state.Scene);
      this.state.Modal.modal('hide');
    }
    /**
     * 削除時確認ダイアログモーダルを表示します
     */

  }, {
    key: "openSessionDeleteConfirmModal",
    value: function openSessionDeleteConfirmModal() {
      this.setState({
        SessionConfirmModalMode: SessionConfirmModalComponent.Mode.SessionDeleteConfirm
      });
    }
    /**
     * 確認ダイアログモーダルで「はい」を選択した際の処理を行います。
     */

  }, {
    key: "yesSessionConfirmModal",
    value: function yesSessionConfirmModal(closeEvent) {
      closeEvent();

      if (this.state.Modal == null || !this.props.sessionId || !this.props.updateDateTime) {
        throw Error();
      }

      this.props.onDelete(this.props.sessionId, this.props.updateDateTime);
      this.state.Modal.modal('hide');
    }
    /**
     * 確認ダイアログモーダルで「いいえ」を選択した際の処理を行います。
     */

  }, {
    key: "noSessionConfirmModal",
    value: function noSessionConfirmModal(closeEvent) {
      closeEvent();
    }
    /**
     * 確認ダイアログモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenSessionConfirmModal",
    value: function hiddenSessionConfirmModal() {
      this.setState({
        SessionConfirmModalMode: SessionConfirmModalComponent.Mode.None
      });
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onClose",
    value: function onClose() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var modal = $('#SessionModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function (e) {
        _this3.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_Calender.svg"
      }), this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("h3", null, intl.format(CreateSession.Title)), this.props.mode == Mode.Modify && [/*#__PURE__*/React.createElement("h3", null, intl.format(CreateSession.EditTitle))], this.props.mode == Mode.ReadOnly && [/*#__PURE__*/React.createElement("h3", null, intl.format(CreateSession.ViewTitle))]), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-8 leftArea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "SessionName"
      }, intl.format(Label.Name)), this.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "SessionName",
        id: "SessionName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this4.updateSessionName(e);
        },
        value: this.state.SessionName,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "SessionName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "SessionName",
        id: "SessionName",
        readOnly: true,
        value: this.state.SessionName,
        tabIndex: 101
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "StartDate"
      }, intl.format(Label.StartDate)), this.props.mode != Mode.ReadOnly && [/*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "StartDate",
        id: "StartDate",
        tabIndex: 103,
        selected: this.state.StartDate,
        onChange: this.updateStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeHours_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.StartTimeHours).padStart(2, "0"),
        onChange: this.updateStartTimeHours.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateHoursListItems(this.updateStartTimeHours.bind(this)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.StartTimeMinutes).padStart(2, "0"),
        onChange: this.updateStartTimeMinutes.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateUnitsOf15MinutesListItems(this.updateStartTimeMinutes.bind(this))))], this.props.mode == Mode.ReadOnly && [/*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "StartDate",
        id: "StartDate",
        disabled: true,
        tabIndex: 103,
        selected: this.state.StartDate,
        onChange: this.updateStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeHours_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.StartTimeHours).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.StartTimeMinutes).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })))]), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, this.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "specifyPeriod"
      }, intl.format(Label.SpecifyPeriod)), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "specifyPeriod",
        name: "specifyPeriod",
        onChange: this.updateSpecifyPeriod.bind(this),
        checked: this.state.SpecifyPeriod
      })), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "specifyPeriod"
      }, intl.format(Label.SpecifyPeriod)), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "specifyPeriod",
        name: "specifyPeriod",
        readOnly: true,
        checked: this.state.SpecifyPeriod
      })))), this.state.SpecifyPeriod && /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "EndDate"
      }, intl.format(Label.EndDate)), this.props.mode != Mode.ReadOnly && [/*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "EndDate",
        id: "EndDate",
        tabIndex: 104,
        selected: this.state.EndDate,
        onChange: this.updateEndDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeHours_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.EndTimeHours).padStart(2, "0"),
        onChange: this.updateEndTimeHours.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateHoursListItems(this.updateEndTimeHours.bind(this)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.EndTimeMinutes).padStart(2, "0"),
        onChange: this.updateEndTimeMinutes.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateUnitsOf15MinutesListItems(this.updateEndTimeMinutes.bind(this))))], this.props.mode == Mode.ReadOnly && [/*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "EndDate",
        id: "EndDate",
        disabled: true,
        tabIndex: 104,
        selected: this.state.EndDate,
        onChange: this.updateEndDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeHours_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.EndTimeHours).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.EndTimeMinutes).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })))])), /*#__PURE__*/React.createElement("div", {
        className: "col-3 rightArea"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        className: "title-label"
      }, intl.format(Label.SceneSelection))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "sceneImageFrame"
      }, /*#__PURE__*/React.createElement("img", {
        className: "sceneImage loadingImage-0 loading-spinner",
        src: "/assets/img/Loading.svg"
      }), /*#__PURE__*/React.createElement("img", {
        className: "sceneImage sceneImage-0 loading-hidden",
        src: "/assets/img/noimage.png"
      }), /*#__PURE__*/React.createElement("img", {
        className: "scene360 scene360-0 hidden",
        src: "/assets/img/Icon_360Image.svg"
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        className: "display-label"
      }, this.state.Scene ? this.state.Scene.SceneDisplayName : this.state.SceneImageName)), this.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "imgAndTextBtn",
        onClick: this.onChangeScene.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.Change))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer modal-footer-container justify-content-center"
      }, this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry)), this.props.mode == Mode.Modify && [/*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), /*#__PURE__*/React.createElement("button", {
        key: "onDuplicate",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDuplicate.bind(this),
        tabIndex: -1
      }, intl.format(Action.Duplicate)), /*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDelete.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))], this.props.mode == Mode.ReadOnly && this.props.isMyMeeting && [/*#__PURE__*/React.createElement("button", {
        key: "onDuplicate",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDuplicate.bind(this),
        tabIndex: -1
      }, intl.format(Action.Duplicate)), /*#__PURE__*/React.createElement("button", {
        key: "button",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close))], this.props.mode == Mode.ReadOnly && !this.props.isMyMeeting && [/*#__PURE__*/React.createElement("button", {
        key: "button",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close))])))), this.state.SessionConfirmModalMode != SessionConfirmModalComponent.Mode.None && /*#__PURE__*/React.createElement(SessionConfirmModalComponent["default"], {
        mode: this.state.SessionConfirmModalMode,
        onYes: this.yesSessionConfirmModal.bind(this),
        onNo: this.noSessionConfirmModal.bind(this),
        onHidden: this.hiddenSessionConfirmModal.bind(this)
      }));
    }
  }]);

  return SessionModalComponent;
}(React.Component);

export { SessionModalComponent as default };